import React, { PropsWithChildren, useEffect } from 'react';
import { useIntercom } from 'react-use-intercom';
import useSession from 'hooks/useSession';
import Header from '../components/Header';
import LoadingPage from '../auth/LoadingPage';
import { getShopDomain, useAppBridge } from './AppBridge';

const AppContainer: React.FC<PropsWithChildren<{}>> = ({
  children,
}: PropsWithChildren<{}>) => {
  const embeddedInShopifyAdmin = window.parent !== window;
  const app = useAppBridge();
  const { boot } = useIntercom();
  const { authorizationUrl, refreshSessionToken } = useSession(
    (state) => state
  );

  useEffect(() => {
    // Boot Intercom only after OAuth so the messenger isn't interactive
    // pre-auth (Shopify App Store rule 2.3.2), and after the initial paint so
    // the chat bundle does not compete with dashboard LCP.
    const timeout = window.setTimeout(() => {
      boot({
        name: getShopDomain().replace('.myshopify.com', ''),
      });
    }, 5000);

    return () => window.clearTimeout(timeout);
  }, [boot]);

  useEffect(() => {
    if (authorizationUrl) {
      app.redirect(authorizationUrl, 'Remote');
    }
  }, [app, authorizationUrl]);

  useEffect(() => {
    refreshSessionToken(app.getSessionToken);
  }, [refreshSessionToken, app]);

  return embeddedInShopifyAdmin ? (
    <>
      <Header />
      {children}
    </>
  ) : (
    <LoadingPage />
  );
};

export default AppContainer;
